exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sign-success[data-v-48719ea4]{text-align:center;padding-bottom:.4rem}.sign-success img[data-v-48719ea4]{width:1.6rem;margin-bottom:.4rem}.sign-success .sign-success_title[data-v-48719ea4]{color:#000;font-size:.32rem;line-height:.4rem;font-weight:bold}.sign-success .sign-success_tip[data-v-48719ea4]{color:#b4b4b4;font-size:.18rem;margin-top:.12rem}", ""]);

// exports
